import { useState, useEffect, useCallback } from 'react';
var API = 'https://api.algrok.com';
function fmtRs(n){if(n==null||isNaN(n))return'--';var a=Math.abs(Math.round(n));return(n>=0?'+':'-')+a.toLocaleString('en-IN')+'\u20B9';}

export default function JPSignalM(){
  var [state,setState]=useState(null);
  var [showLogs,setShowLogs]=useState(false);
  var [nextLots,setNextLots]=useState(0);

  var fetchState=useCallback(function(){
    fetch(API+'/tv-state').then(function(r){return r.json();}).then(function(d){if(!d.error)setState(d);}).catch(function(){});
  },[]);
  useEffect(function(){fetchState();var id=setInterval(fetchState,2000);return function(){clearInterval(id);};},[fetchState]);
  useEffect(function(){if(state&&state.next_lots>0&&nextLots===0)setNextLots(state.next_lots);},[state]);

  var doApi=function(url,body){
    fetch(API+url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body||{})}).then(function(){fetchState();}).catch(function(){});
  };

  if(!state)return<div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',background:'#05080f',color:'#4a5c72'}}>Loading...</div>;

  var pos=state.position;
  var pnl=state.pnl||{};
  var totalPnl=(pnl.realized||0)+(pnl.unrealized||0);
  var running=state.running;
  var paused=state.config&&state.config.paused;
  var events=state.events||[];
  var cfg=state.config||{};
  var lots=nextLots||state.next_lots||cfg.lots||1;
  var posDir=pos?(pos.optType||pos.side):null;
  var posPnl=0;
  if(pos&&pos.entry_price&&pos.ltp){posPnl=(pos.side==='BUY'?(pos.ltp-pos.entry_price):(pos.entry_price-pos.ltp))*(pos.qty||0);}
  var G='#00d4aa',R='#ff4466',Y='#fbbf24',M='#4a5c72',T='#e2e8f0',BD='rgba(26,45,74,0.35)',CD='rgba(12,18,32,0.95)';

  return(
  <div style={{minHeight:'100vh',background:'#05080f',color:T,fontFamily:"system-ui,sans-serif",paddingTop:'env(safe-area-inset-top,0)',paddingBottom:70,WebkitFontSmoothing:'antialiased',overflowX:'hidden'}}>
    <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'14px 16px 10px',borderBottom:'1px solid '+BD}}>
      <div style={{display:'flex',alignItems:'center',gap:8}}>
        <div style={{width:8,height:8,borderRadius:'50%',background:running?(paused?Y:G):R,boxShadow:running&&!paused?'0 0 8px '+G:'none'}}/>
        <span style={{fontSize:15,fontWeight:800}}>JP Signal</span>
      </div>
      {posDir&&<span style={{padding:'3px 10px',borderRadius:20,fontSize:11,fontWeight:800,color:posDir==='CE'?G:R,background:(posDir==='CE'?G:R)+'15',border:'1px solid '+(posDir==='CE'?G:R)+'30'}}>{posDir==='CE'?'\u25B2 LONG CE':'\u25BC LONG PE'}</span>}
      {!pos&&<span style={{padding:'3px 10px',borderRadius:20,fontSize:11,fontWeight:700,color:M,background:'rgba(85,102,119,0.1)',border:'1px solid '+BD}}>No Position</span>}
    </div>
    <div style={{textAlign:'center',padding:'28px 16px 20px'}}>
      <div style={{fontSize:42,fontWeight:900,color:totalPnl>=0?G:R,letterSpacing:'-2px',lineHeight:1}}>{fmtRs(totalPnl)}</div>
      <div style={{display:'flex',justifyContent:'center',gap:16,marginTop:10}}>
        <span style={{fontSize:11,color:M}}>R: <span style={{color:T,fontWeight:700}}>{fmtRs(pnl.realized)}</span></span>
        <span style={{fontSize:11,color:M}}>U: <span style={{color:T,fontWeight:700}}>{fmtRs(pnl.unrealized)}</span></span>
      </div>
    </div>
    {pos&&<div style={{margin:'0 12px 12px',background:CD,borderRadius:14,border:'1px solid '+BD}}>
      <div style={{padding:'14px 16px'}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
          <div>
            <div style={{fontSize:13,fontWeight:800}}>{pos.symbol}</div>
            <div style={{fontSize:10,color:M,marginTop:2}}>x{pos.qty} · {pos.side} · Since {pos.entered_at||pos.entry_time}</div>
          </div>
          <div style={{fontSize:18,fontWeight:900,color:posPnl>=0?G:R}}>{fmtRs(posPnl)}</div>
        </div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:8,marginTop:14}}>
          {[{l:'Entry',v:'\u20B9'+(pos.entry_price||0).toFixed(1)},{l:'LTP',v:'\u20B9'+(pos.ltp||0).toFixed(1)},{l:'Strike',v:pos.strike}].map(function(c){
            return<div key={c.l} style={{background:'rgba(0,0,0,0.25)',borderRadius:8,padding:'8px 10px'}}>
              <div style={{fontSize:8,color:M,fontWeight:700,textTransform:'uppercase'}}>{c.l}</div>
              <div style={{fontSize:14,fontWeight:800}}>{c.v}</div>
            </div>;
          })}
        </div>
      </div>
    </div>}
    <div style={{margin:'0 12px 12px',background:CD,borderRadius:14,border:'1px solid '+BD,padding:'14px 16px'}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:14}}>
        <span style={{fontSize:11,color:M,fontWeight:700}}>NEXT SIGNAL LOTS</span>
        <div style={{display:'flex',alignItems:'center'}}>
          <div onClick={function(){var n=Math.max(1,lots-1);setNextLots(n);doApi('/tv-lots',{lots:n});}} style={{width:36,height:36,borderRadius:'8px 0 0 8px',border:'1px solid '+BD,background:'rgba(0,0,0,0.3)',color:T,fontSize:18,fontWeight:700,display:'flex',alignItems:'center',justifyContent:'center'}}>-</div>
          <div style={{width:48,height:36,display:'flex',alignItems:'center',justifyContent:'center',background:'rgba(0,0,0,0.5)',borderTop:'1px solid '+BD,borderBottom:'1px solid '+BD,fontSize:16,fontWeight:900}}>{lots}</div>
          <div onClick={function(){var n=lots+1;setNextLots(n);doApi('/tv-lots',{lots:n});}} style={{width:36,height:36,borderRadius:'0 8px 8px 0',border:'1px solid '+BD,background:'rgba(0,0,0,0.3)',color:T,fontSize:18,fontWeight:700,display:'flex',alignItems:'center',justifyContent:'center'}}>+</div>
          <div style={{fontSize:9,color:M,marginLeft:8}}>x65={lots*65}</div>
        </div>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginBottom:10}}>
        {!paused?<div onClick={function(){doApi('/tv-stop',{action:'stop'});}} style={{padding:12,borderRadius:10,border:'1px solid '+Y+'40',background:Y+'10',color:Y,fontSize:13,fontWeight:800,textAlign:'center'}}>{'\u23F8'} Pause</div>
        :<div onClick={function(){doApi('/tv-start',{action:'start'});}} style={{padding:12,borderRadius:10,border:'1px solid '+G+'40',background:G+'10',color:G,fontSize:13,fontWeight:800,textAlign:'center'}}>{'\u25B6'} Resume</div>}
        <div onClick={function(){if(window.confirm('Exit position?'))doApi('/tv-stop',{action:'exit',reason:'Manual exit'});}} style={{padding:12,borderRadius:10,border:'1px solid '+R+'40',background:R+'10',color:R,fontSize:13,fontWeight:800,textAlign:'center'}}>{'\u23F9'} Exit</div>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8}}>
        <div onClick={function(){doApi('/tv-start',{action:'enter',signal_type:'BUY',lots:lots});}} style={{padding:12,borderRadius:10,border:'1px solid '+G+'30',background:'rgba(0,0,0,0.3)',color:G,fontSize:12,fontWeight:800,textAlign:'center'}}>{'\u25B2'} Force BUY</div>
        <div onClick={function(){doApi('/tv-start',{action:'enter',signal_type:'SELL',lots:lots});}} style={{padding:12,borderRadius:10,border:'1px solid '+R+'30',background:'rgba(0,0,0,0.3)',color:R,fontSize:12,fontWeight:800,textAlign:'center'}}>{'\u25BC'} Force SELL</div>
      </div>
    </div>
    <div style={{margin:'0 12px'}}>
      <div onClick={function(){setShowLogs(!showLogs);}} style={{padding:'12px 16px',borderRadius:showLogs?'14px 14px 0 0':'14px',border:'1px solid '+BD,background:CD,color:M,fontSize:12,fontWeight:700,display:'flex',justifyContent:'space-between'}}>
        <span>{'\uD83D\uDCCB'} Activity Log ({events.length})</span>
        <span style={{transform:showLogs?'rotate(180deg)':'none',transition:'transform 0.2s'}}>{'\u25BE'}</span>
      </div>
      {showLogs&&<div style={{background:CD,borderRadius:'0 0 14px 14px',border:'1px solid '+BD,borderTop:'none',padding:'8px 12px',maxHeight:280,overflowY:'auto',WebkitOverflowScrolling:'touch'}}>
        {events.slice().reverse().slice(0,30).map(function(e,i){
          var c=e.type==='success'?G:e.type==='error'?R:e.type==='warning'?Y:M;
          return<div key={i} style={{fontSize:10,color:c,padding:'4px 0',borderBottom:'1px solid rgba(26,45,74,0.15)',fontFamily:'monospace'}}>
            <span style={{color:M,marginRight:6}}>{e.ts}</span>{e.msg}
          </div>;
        })}
      </div>}
    </div>
  </div>);
}
